module.exports = __webpack_public_path__ + "teqbahn-assets/media/Slide2LogoBG.0521a066.png";